import axios from "axios";

const API =
  process.env.REACT_APP_API_URL ||
  "http://localhost:5000";

const axiosInstance = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const getTodayPortal = async () => {
  const { data } = await axiosInstance.get("/academic-calendar-portal/today");
  return data;
};

export const initializeYearPortal = async (year) => {
  const { data } = await axiosInstance.post("/academic-calendar-portal/initialize", { year });
  return data;
};

export const getMonthPortal = async (year, month) => {
  const { data } = await axiosInstance.get(`/academic-calendar-portal/month/${year}/${month}`);
  return data;
};

export const getYearSummaryPortal = async (year) => {
  const { data } = await axiosInstance.get(`/academic-calendar-portal/year/${year}`);
  return data;
};

export const markDayPortal = async (payload) => {
  const { data } = await axiosInstance.post("/academic-calendar-portal/mark", payload);
  return data;
};

export const markDaysRangePortal = async (payload) => {
  const { data } = await axiosInstance.post("/academic-calendar-portal/mark-range", payload);
  return data;
};

export const resetDayPortal = async (date) => {
  const { data } = await axiosInstance.delete(`/academic-calendar-portal/reset/${date}`);
  return data;
};
